import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core'

const SCROLL_THRESHOLD = 150

@Component({
  selector: 'scroll-button',
  templateUrl: './scroll-button.component.html',
  styleUrls: ['./scroll-button.component.scss'],
})
export class ScrollButtonComponent implements AfterViewInit, OnChanges {
  @ViewChild('leftBtn') leftBtn: ElementRef<HTMLInputElement>
  @ViewChild('rightBtn') rightBtn: ElementRef<HTMLInputElement>

  @Input() leftHtmlId: string
  @Input() selectionChanged: any
  @Input() passedTable: HTMLDivElement
  @Input() scrollWidth: number
  @Input() offsetWidth: number

  @Output() scrollableEmitter = new EventEmitter<boolean>()

  isScrollableForWindowSize: boolean
  showRightButton = true
  currentTr: any
  currentTh: any
  clickDirection = ''

  ngOnChanges(changes: SimpleChanges): void {
      if (changes?.selectionChanged && Array.isArray(changes.selectionChanged.currentValue)) {
        this.selectionChanged = 'pcf-holdings'
      }
    this.determineScrollable(!changes?.selectionChanged?.firstChange)
  }

  ngAfterViewInit(): void {
    this.determineScrollable(false)
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    setTimeout(
      () => {
        this.determineScrollable(false)
      }, // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      10,
    )
  }
  // eslint-disable-next-line complexity, max-statements
  determineScrollable(isChanges: boolean) {
    if (!this.currentTh || isChanges) {
      this.currentTh = this.passedTable?.querySelector(
        '#'.concat(this.leftHtmlId),
      )
    }
    if (!this.currentTr || isChanges) {
      this.currentTr =
        this.passedTable.parentNode.querySelector('#btn-container')
    }
    this.isScrollableForWindowSize =
      this.scrollWidth > window.innerWidth ||
      (window.innerWidth === undefined && this.scrollWidth > 0)
    this.scrollableEmitter.emit(
      this.isScrollableForWindowSize &&
        this.selectionChanged !== 'pcf-holdings',
    )

    this.scrollTableHandler()
  }
  scrollTableHandler() {
    if (this.isScrollableForWindowSize) {
      if (this.currentTr) {
        this.currentTr.appendChild(this.rightBtn?.nativeElement)
      }
      if (this.currentTh) {
        this.currentTh.appendChild(this.leftBtn?.nativeElement)
      }
      this.determineShowRight()
    }
  }
  moveRight() {
    this.passedTable.scrollTo({
      left: this.passedTable.scrollLeft + SCROLL_THRESHOLD,
      behavior: 'smooth',
    })
    this.clickDirection = 'right'
    this.determineShowRight()
  }

  moveLeft() {
    this.clickDirection = 'left'
    this.determineShowRight()
    this.passedTable.scrollTo({
      left: this.passedTable.scrollLeft - SCROLL_THRESHOLD,
      behavior: 'smooth',
    })
  }
  determineShowRight() {
    this.showRightButton =
      this.passedTable.offsetWidth + this.passedTable.scrollLeft >=
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        this.passedTable.scrollWidth - 160 && this.clickDirection !== 'left'
        ? false
        : true
  }
}
